import React, { useEffect, useState } from "react";
import { socket } from "../../socketGlobal";
import { useLocation, useNavigate } from "react-router-dom";
import { SideMenu } from "../Side-Menu/sideMenu";
import axios from "axios";
import { mainServerAppUrl } from "../../apis/mainApi";
import { toast } from "react-hot-toast";
import { getAuthUser } from "../Authentication/authHelper";

export const PaymentSuccess = () => {
  const [customerName, setCustomerName] = useState("");
  const [customerSession, setCustomerSession] = useState({});
  const [role, setRole] = useState(localStorage.getItem("Role"));
  const [token, setToken] = useState("");
  const navigate = useNavigate();
  const location = useLocation(); 
  const path = location.search;
  const sessionId = path.split("=")[1];
  const email = localStorage.getItem("email");
  const password = localStorage.getItem("password");
  const data = { email, password };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

useEffect(() => {
  if (!sessionId) return;

  axios
    .get(`${mainServerAppUrl}/payment-success/${sessionId}`)
    .then((res) => {
      const { amount, customerId } = res.data;

      if (amount && customerId) {
        toast.success(`Payment of $${amount} successful`);
      }
       setCustomerSession(res.data)
      if (role === "MealHost") {
        loginUser(data);
      }
    })
    .catch(console.error);
}, [sessionId]);

// Listen for paymentSuccess socket event
useEffect(() => {
  if (!socket.connected) {
    socket.connect();
  }
  const handlePaymentSuccess = (data) => {
    toast.success(`Payment Success! Order: ${data.orderId}, Amount: $${data.amount / 100 || data.amount}`);
    // Optionally update state/UI here
  };
  socket.on("paymentSuccess", handlePaymentSuccess);
  return () => {
    socket.off("paymentSuccess", handlePaymentSuccess);
  };
}, []);


  const loginUser = (data) => {
    axios
      .post(mainServerAppUrl + "/user/login", {
        email: data?.email,
        password: data?.password,
      })
      .then((result) => {
        localStorage.setItem("_token", result?.data?.token);
        setToken(localStorage.getItem("_token"));
        setCustomerName(
          getAuthUser()?.first_name + " " + getAuthUser()?.last_name
        );
        localStorage.removeItem("email");
        localStorage.removeItem("password");
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return role === "Patron" ? (
    <div className="max-resolution">
      <header>
        <div className="header-info">
          <div className="left-part">
            {/* <!-- <img src="common/images/food1.png" className="img-fluid" alt="Register Banner"> --> */}
            <a href="/patron-home" className="site-logo">
              <img src={require("../../assets/images/thcm-logo-red.png")} />
            </a>
          </div>
          <div className="right-part">
            <h1>Homey-FOODS</h1>
            <p>
              Throughout human history in all cultures food is an important
              basis of social bonding. With our increasing human family
              worldwide. Homey-FOODS offering a venue for all to enjoy unique
              cuisines, healthy regional foods by many who enjoy cooking and
              eager to serve variety of foods.{" "}
            </p>
            <p>
              <span>
                “Restaurant Meals can increase cardiovascular disease
                risk”Journal of the Academy of Nutrition and Dietetics-March
                2021
              </span>
            </p>
          </div>
        </div>
      </header>
      <main>
        <div className="home-section-1 position-relative">
          {/* <SideMenu /> */}
          <h2>Easy and Fast Access to Homey-FOODS</h2>
        </div>
        <div className="custom-form centered pb-4">
          <form>
            <div className="col-12 not_found">
              <p>
                Hi {customerName}, your payment of $
                {customerSession?.amount / 100} is {customerSession?.status}
                .
                <br />
                Customer ID - {customerSession?.customerId}
              </p>
              <span
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "15px",
                  paddingBottom: "15px",
                  textAlign: "center",
                }}
              >
                Note: Use the Customer ID in case of any payment enquiry.
              </span>
            </div>
            {customerName && (
              <div className="col-12 p-0">
                <button
                  className="btn w-100"
                  onClick={(e) => {
                    e.preventDefault();
                    navigate("/mealhost-contact");
                  }}
                >
                  Go to MealHost Contact
                </button>
              </div>
            )}
          </form>
        </div>
      </main>
      <footer>
        <div className="footer-content">
          <div className="disclaimer">
            <p className="pb-2">DISCLAIMER</p>
          </div>
          <p>
            Homey-FOODS is a service that brings Meal Hosts and Patrons
            together. Homey-FOODS makes no representations, endorsements. or
            warranties of any kind whatsoever of Meal Hosts and Customers. Both
            parties agree to comply to local government laws, be of legal age
            and Homey-FOODS shall not be held responsible from disputes, damages
            and controversies.
          </p>
        </div>
        <div className="footer_bottom">
          <a href="https://www.homey-foods.com" className="site_link">
            www.homey-foods.com
          </a>
          <div className="social-media">
            <ul>
              <li>
                <a href="#" target="_blank">
                  <i className="fab fa-facebook-f"></i>
                </a>
              </li>
              <li>
                <a href="#" target="_blank">
                  <i className="fab fa-twitter"></i>
                </a>
              </li>
              <li>
                <a href="#" target="_blank">
                  <i className="fab fa-linkedin"></i>{" "}
                </a>
              </li>
              <li>
                <a href="#" target="_blank">
                  <i className="fab fa-instagram"></i>
                </a>
              </li>
            </ul>
          </div>
          <p>© 2023 Homey-FOODS</p>
        </div>
      </footer>
    </div>
  ) : (
    <div className="max-resolution">
      <header>
        <div className="header-info">
          <div className="left-part">
            {/* <!-- <img src="common/images/food1.png" className="img-fluid" alt="Register Banner"> --> */}
            <a
              href="/mealhost-home"
              className="site-logo"
              onClick={(e) => {
                e.preventDefault();
                navigate("/mealhost-home");
              }}
            >
              <img src={require("../../assets/images/thcm-logo-red.png")} />
            </a>
          </div>
          <div className="right-part">
            <h1>Homey-FOODS</h1>
            <p>
              Throughout human history in all cultures food is an important
              basis of social bonding. With our increasing human family
              worldwide. Homey-FOODS offering a venue for all to enjoy unique
              cuisines, healthy regional foods by many who enjoy cooking and
              eager to serve variety of foods.{" "}
            </p>
            <p>
              <span>
                “Restaurant Meals can increase cardiovascular disease
                risk”Journal of the Academy of Nutrition and Dietetics-March
                2021
              </span>
            </p>
          </div>
        </div>
      </header>
      <section className="title_box">
        <div className="container position-relative">
          {/* <span className="position-relative"> */}
          {/* <SideMenu /> */}
          {/* </span> */}
          
          <p>
            Use culinary skills offer regional cuisines and become financially
            successful.{" "}
          </p>
          <h2>YOU ARE NOW A MEAL HOST- CONGRATULATIONS</h2>
        </div>
      </section>
      <main style={{ padding: "1rem 0" }}>
        <div className="container">
          <div className="custom-form centered mb-4">
            {token !== null && (
              <form>
                <div className="col-12 not_found">
                  <p
                    style={{
                      fontSize: "18px",
                      fontWeight: "900",
                      textAlign: "center",
                      marginBottom: "1rem",
                      marginTop: "10rem",
                    }}
                  >
                    Thank you {customerName}, for subscribing to the yearly plan
                    of Homey-FOODS. Your payment of $
                    {customerSession.amount_total / 100} is{" "}
                    {customerSession.status}, and your subscription is now
                    active.
                  </p>
                </div>
                {/* <div className="col-12 p-0">
                  <button
                    className="btn w-100"
                    style={{ marginTop: '7rem' }}
                    onClick={(e) => {
                      e.preventDefault();
                      navigate("/mealhost-code-of-Conduct");
                    }}
                  >
                    Done
                  </button>
                </div> */}
              </form>
            )}
          </div>
        </div>
      </main>
      <footer>
        <div className="container">
          <p className="pb-2">DISCLAIMER</p>
          <p>
            Homey-FOODSis a service that brings Meal Hosts and Patrons together.
            Homey-FOODS makes no representations, endorsements. or warranties of
            any kind whatsoever of Meal Hosts and Customers. Both parties agree
            to comply to local government laws, be of legal age and Homey-FOODS
            shall not be held responsible from disputes, damages and
            controversies.
          </p>
          <div className="footer_bottom text-center">
            <a href="https://www.homey-foods.com" className="site_link my-3">
              www.homey-foods.com
            </a>
            <div className="social-media">
              <ul>
                <li>
                  <a href="#" target="_blank">
                    <i className="fab fa-facebook-f"></i>
                  </a>
                </li>
                <li>
                  <a href="#" target="_blank">
                    <i className="fab fa-twitter"></i>
                  </a>
                </li>
                <li>
                  <a href="#" target="_blank">
                    <i className="fab fa-linkedin"></i>{" "}
                  </a>
                </li>
                <li>
                  <a href="#" target="_blank">
                    <i className="fab fa-instagram"></i>
                  </a>
                </li>
              </ul>
            </div>
            <p>© 2023 Homey-FOODS</p>
          </div>
        </div>
      </footer>
    </div>
  );
};
